import { isNotEmptyArray } from "../../../shared/utils/isNotEmptyArray";
import { MenuItem, MenuItems } from "../types";

export const findObjectById = (
  id: string,
  menuItems: MenuItems | null
): MenuItem | null => {
  if (!menuItems) return null;

  for (const item of menuItems) {
    if (item.id === id) {
      return item;
    }

    if (isNotEmptyArray(item.children)) {
      const child = findObjectById(id, item.children);
      if (child) {
        return child;
      }
    }
  }
  return null;
};
